import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWillsAndTrustsMedicaidAssetProtectionTrustInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-wills-and-trusts/medicaid-asset-protection-trust-in-new-york/']} />;
}
